module.exports = __webpack_public_path__ + "static/media/grimstroke.12a38ba9.png";